module.exports = __webpack_public_path__ + "static/media/23-3.9d45f84e.png";